import { Component, HostBinding, ViewEncapsulation } from '@angular/core';
import { FieldWrapper } from '@ngx-formly/core';

@Component({
  selector: 'form-fieldset-wrapper',
  standalone: false,
  encapsulation: ViewEncapsulation.None,
  styles: ['.form-fieldset-wrapper { display:flex;}'],
  template: `
    <p-fieldset
      class="flex-1"
      legend="{{
        props['translate'] ? (props.label || '' | translate) : props.label
      }}"
      [toggleable]="true"
    >
      <ng-container #fieldComponent></ng-container>
    </p-fieldset>
    <!-- <div class="card">
      <h3 class="card-header">{{ props.label }}</h3>
      <div class="card-body">
        <ng-container #fieldComponent></ng-container>
      </div>
    </div>-->
  `,
})
export class FormFieldsetWrapperType extends FieldWrapper {
  @HostBinding('class')
  readonly cssClass = 'form-fieldset-wrapper';
}
